<span class="single-option" [ngClass]="automationClass" >{{reviseOption.display | translate}}</span>
